import React, { useState, useEffect } from "react";

import { func_validation, isArrayNotEmpty } from "functions";
import { ListBox } from "components/form/ListBox";
import useRecursiveBillingSetup from "dataflow/billingPortal/actions/useRecursiveBillingSetup.actions";
import { useCustomSelector } from "hooks";

export function useProductList(props) {
    const { isFormSubmissionAttempted } = props;

    const { getFullProductDetailList_requesting, fullProductDetailList } =
      useCustomSelector("recursiveBillingSetup");

    const { getFullProductDetailList } = useRecursiveBillingSetup();
    const [productList, setProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);

    useEffect(() => {
      // Get data initially
      getFullProductDetailList();
    }, []);

    useEffect(() => {
        if (isArrayNotEmpty(fullProductDetailList)) {
            setProductList(fullProductDetailList);
        }
    }, [JSON.stringify(fullProductDetailList)]);

    let productDisplay = (
        <ListBox
            className={"product-inputWrapper"}
            listWrapperClassName={"product-inputWrapper-listWrapper"}
            listBodyClassName={"product-inputWrapper-listBody"}

            customSelectionIndicatorTxt={"Product(s) Selected"}

            title={"Select Product(s)"}
            isFormSubmissionAttempted={isFormSubmissionAttempted}

            list={isArrayNotEmpty(productList)? 
                productList.map((product) => {
                    return {
                        label: product.ProductName, 
                        data: product.ProductCode
                    }
            }):[]}
            isListLoading={getFullProductDetailList_requesting}

            updateParentState={setSelectedProduct}
        />
    )

    return {
        selectedProduct,
        productDisplay
    }
}